/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ImportItemDisplay from 'app/components/Importer/ImportItemDisplay.jsx';
import SocialButton from 'app/components/common/SocialButton.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import SelectorTools from 'app/utility/SelectorTools.js';
import DropdownList from 'react-widgets/DropdownList';
import CategoryItem from 'app/components/DropDownItems/CategoryItem.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class ImportResults extends React.Component {
    constructor(props) {
        super(props);

        let constants = this.props.app.config.constants;

        this.state = {
            categories: [],
            display: 'grid',
            selectedItems: [],
            params: {
                postPoolFlag: 0,
                postQueueFlag: 1,
                hashTags: {
                    hashPlacement: constants.HASH_POST,
                    hashStatic: []
                },
                creditFlag: 0,
                tagID: 0
            },
            confirmationBanner: false,
            socials: [],
            twitterOutputs: [],
            localErrors: {
                hashStatic: ''
            }
        };

        this.selectItem = this.selectItem.bind(this);
        this.importItems = this.importItems.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onEverqueueChange = this.onEverqueueChange.bind(this);
        this.dismissConfirmation = this.dismissConfirmation.bind(this);
        this.bulkSelect = this.bulkSelect.bind(this);
        this.toggleDisplay = this.toggleDisplay.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onChooseSocials = this.onChooseSocials.bind(this);
        this.updateHashtags = this.updateHashtags.bind(this);
        this.primeCategories = this.primeCategories.bind(this);

        this.importErrorRef = React.createRef();

    }

    componentDidMount() {

        let selectedItems = this.state.selectedItems;

        if (this.props.context === 'csv') {
            // default state for csv import items is 'select all'
            for (let i = 0; i < this.props.items.length; ++i) {
                if (this.props.items[i].id && (this.props.items[i].item.imgErrorMsg === '' && this.props.items[i].item.urlErrorMsg === '')) {
                    selectedItems.push(this.props.items[i].id);
                }
            }

            this.setState({
                selectedItems
            });
        }

        if (this.props.categories.length) {
            this.primeCategories();
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let constants = this.props.app.config.constants;

        if (prevProps.categories !== this.props.categories) {
            this.primeCategories();
        }

        if (prevProps.importError === null && this.props.importError) {
            if (this.importErrorRef.current !== null) {
                this.importErrorRef.current.scrollIntoView();
            }
            this.setState({
                selectedItems: []
            });
        }

        if (prevProps.importComplete === false && this.props.importComplete === true) {
            this.setState({
                selectedItems: [],
                params: {
                    postPoolFlag: 0,
                    postQueueFlag: 1,
                    hashTags: {
                        hashPlacement: constants.HASH_POST,
                        hashStatic: []
                    },
                    creditFlag: 0,
                    tagID: 0
                },
                confirmationBanner: true
            });
        }

    }

    primeCategories() {

        let categories = _.clone(this.props.categories);

        categories.unshift({
            'id': 0,
            'name': 'No Category',
            'color': '#888888'
        });

        this.setState({
            categories
        });

    }

    selectItem(e) {
        let id = parseInt(e.currentTarget.dataset.id),
            selectedItems = this.state.selectedItems;

        if (selectedItems.find((item) => { return id === item; }) === undefined) {
            selectedItems.push(id);
        } else {
            selectedItems.splice(selectedItems.indexOf(id), 1);
        }

        this.setState({
            selectedItems
        });

    }

    bulkSelect(e) {
        let action = e.currentTarget.dataset.action,
            selectedItems = this.state.selectedItems;

        if (action === 'all') {
            for (let i = 0; i < this.props.items.length; ++i) {
                if (selectedItems.indexOf(this.props.items[i].id) === -1) {
                    selectedItems.push(this.props.items[i].id);
                }
            }
        } else {
            selectedItems = [];
        }

        this.setState({
            selectedItems
        });

    }

    toggleDisplay(e) {
        let display = e.currentTarget.dataset.display;

        this.setState({
            display
        });

    }

    importItems(e) {

        this.props.onImportItems.apply(this, [this.state.selectedItems, this.state.params]);

    }

    dismissConfirmation(e) {

        e.preventDefault();

        this.setState({
            confirmationBanner: false
        });

    }

    onCategoryChange(category, e) {

        let params = this.state.params;

        params.tagID = category.id;

        this.setState({
            params
        });

    }

    onInputChange(e) {
        let toggleEvent = {
                target: {
                    value: 0
                },
                currentTarget: {
                    dataset: {
                        field: '',
                        togglestate: 'true'
                    }
                }
            },
            untoggleEvent = {
                target: {
                    value: 1
                },
                currentTarget: {
                    dataset: {
                        field: '',
                        togglestate: 'false'
                    }
                }
            };

        FormUtilityMixin.requestChange.apply(this, [e]);

        // Toggle active pool or queue flag if the other is activated
        // can only import into queue or everqueue, not both
        // Treat the fields as a radio selector, one must be on at all times, but not both
        // if both off, nothing happens and the backend doesn't care because it lives in an if/elseif world
        if (e.currentTarget.dataset.field !== undefined &&
            (e.currentTarget.dataset.field.match("postPoolFlag") ||
            e.currentTarget.dataset.field.match("postQueueFlag"))) {
            if (e.currentTarget.dataset.field.match("postPoolFlag") && e.currentTarget.dataset.togglestate !== 'true' && this.state.params.postQueueFlag) {
                toggleEvent.currentTarget.dataset.field = 'params.postQueueFlag';
                untoggleEvent.currentTarget.dataset.field = 'params.postPoolFlag';
            } else if (e.currentTarget.dataset.field.match("postQueueFlag") && e.currentTarget.dataset.togglestate !== 'true' && this.state.params.postPoolFlag) {
                toggleEvent.currentTarget.dataset.field = 'params.postPoolFlag';
                untoggleEvent.currentTarget.dataset.field = 'params.postQueueFlag';
            }
            FormUtilityMixin.requestChange.apply(this, [toggleEvent]);
            FormUtilityMixin.requestChange.apply(this, [untoggleEvent]);
        }
    }

    onEverqueueChange(e) {

        e.persist();

        let savedEvent = e;

        if (this.props.socials.length) {
            if (this.props.twitterOutputs.length && e.currentTarget.dataset.togglestate === "false") {
                if (_.intersection(this.props.twitterOutputs, this.props.selectedSocials).length) {
                    let confirm = () => {
                            let socials = _.difference(this.props.selectedSocials, this.props.twitterOutputs);
                            this.props.onSocialsSelected(socials);
                            savedEvent.currentTarget = savedEvent.target;
                            this.onInputChange(savedEvent);
                            this.props.closeAllModals(null);
                        },
                        cancel = () => {
                            this.props.closeAllModals(null);
                        },
                        alertModal = (
                            <ConfirmModal
                                modalCopy="Sorry for the hassle, but the Twitter Terms of Service prohibit us from allowing you to add content to EverQueue. Click OK to deselect Twitter and add the content to your other EverQueues"
                                confirmAction={confirm}
                                confirmLabel="OK"
                                cancelAction={cancel}
                                cancelLabel="cancel"/>

                        );
                        this.props.addModal(alertModal);
                        return;
                }
            }

        }

        this.onInputChange(e);

    }

    onChooseSocials(e) {

        this.props.chooseSocials.apply(this, [e, (this.state.params.postPoolFlag) ? true : false]);

    }

    updateHashtags(e) {
        let dataEvent = {
                target: {
                    value: []
                },
                currentTarget: {
                    dataset: e.currentTarget.dataset,
                }
            },
            newValues = e.currentTarget.value.split(" "),
            fieldUpdate = [],
            localErrors = this.state.localErrors,
            constants = this.props.app.config.constants;

        localErrors.hashStatic = '';

        if (newValues.length > constants.HASH_STATIC_MAX) {
            localErrors.hashStatic = "The maximum number of fixed tags allowed is: " + constants.HASH_STATIC_MAX;
        } else {
            for (let i = 0; i < newValues.length; ++i) {
                if (!newValues[i].match(/^\#/) && newValues[i].match(/\w+/)) {
                    newValues[i] = "#" + newValues[i];
                }
                fieldUpdate.push(newValues[i]);
            }
            fieldUpdate = _.uniq(fieldUpdate);

            if (fieldUpdate.length != newValues.length) {
                localErrors.hashStatic = "Duplicate hashtags aren't allowed.";
            }

            dataEvent.target.value = fieldUpdate;

            FormUtilityMixin.requestChange.apply(this, [dataEvent]);

        }

        this.setState({
            localErrors
        });

    }

    render() {
        let socialDisplay = null,
            editControl = null,
            addToQueue = (this.state.params.postQueueFlag) ? true : false,
            addToEverqueue = (this.state.params.postPoolFlag) ? true : false,
            attributionFlag = (this.state.params.creditFlag) ? true : false,
            importFooter = null,
            selectors = new SelectorTools({
                displayGrid: 'view-toggle',
                displayList: 'view-toggle',
                importParams: 'import-params'
            }),
            attributionControl = null,
            tagID = (this.state.params.tagID !== 0) ? this.state.params.tagID : null,
            importError = null,
            hashtagError = null,
            hashtagControl = null;

        if (this.state.display === 'grid') {
            selectors.append('displayGrid', 'active');
        } else if (this.state.display === 'list') {
            selectors.append('displayList', 'active');
        }

        if (this.props.selectedSocials.length > 0) {
            socialDisplay = (
                <div className="import-social-list-wrapper">
                    <ul className="import-social-list">
                        {this.props.selectedSocials.map((id) => {
                            let social = this.props.findSocial(id);

                            if (social) {
                                return (
                                    <li key={"selected-social-" + id}>
                                        <SocialButton
                                            app={this.props.app}
                                            social={social}
                                            frozen={true}/>
                                    </li>
                                );
                            }
                        })}
                    </ul>
                </div>
            );
            editControl = (
                <button className="btn-primary fixed reverse import-socials-edit" onClick={this.onChooseSocials}>Edit Socials</button>
            );
        } else {
            socialDisplay = (
                <button className="btn-primary active import-socials-button" onClick={this.onChooseSocials}>
                    Select Socials
                </button>
            );
        }

        if (this.props.selectedSocials.length > 0 && this.state.selectedItems.length > 0) {
            importFooter = (
                <div className="import-footer">
                    <div className="footer-content">
                        <div>
                            {this.state.selectedItems.length} items selected
                        </div>
                        <div>
                            <button className="btn-primary active import-button" onClick={this.importItems}>
                                Import Items
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        if (this.props.importComplete && this.state.confirmationBanner) {
            importFooter = (
                <div className="import-footer">
                    <div className="footer-content">
                        <div>
                            Good news! All that content has been imported and is ready for posting. Kick back and relax for a minute!
                        </div>
                        <button className="btn-primary fixed" onClick={this.dismissConfirmation}>
                            OK
                        </button>
                    </div>
                </div>
            );
        }

        attributionControl = (
            <div className="import-param">
                <ToggleControl
                    active={attributionFlag}
                    activeLabel="Add attribution to items"
                    inactiveLabel="Add attribution to items"
                    linkedField="params.creditFlag"
                    callback={this.onInputChange}
                    labelPlacement="right" />
            </div>
        );

        hashtagControl = (
            <div className="import-param hashtags">
                {hashtagError}
                <UncontrolledTextInput
                    className="text-input large"
                    placeholder="Add #hashtags? e.g. #news #travel"
                    value={this.state.params.hashTags.hashStatic.join(" ")}
                    onChange={this.updateHashtags}
                    data-field="params.hashTags.hashStatic" />
            </div>
        );

        if (this.props.context === 'csv') {
            attributionControl = null;
            hashtagControl = null;
            selectors.append('importParams', 'csv');
        }

        if (this.props.importError) {
            if (this.props.importError.perms) {
                if (this.props.importError.perms.accounts) {
                    importError = (
                        <div ref={this.importErrorRef} className="import-results-error">
                            <ul>
                            {this.props.importError.perms.accounts.map((account, i) => {
                                return (<li key={'account_error_' + i}>{account.msg}</li>);
                            })}
                            </ul>
                        </div>
                    );
                } else {
                    importError = (
                        <div ref={this.importErrorRef} className="import-results-error">
                            {this.props.importError.perms.msg}
                        </div>
                    );
                }
            } else if (this.props.importError.validation && this.props.importError.validation.params !== undefined) {
                importError = (
                    <div ref={this.importErrorRef} className="import-results-error">
                        The category you selected doesn't have scheduled times for one or more of the socials you selected.
                    </div>
                );
            } else if (this.props.importError.validation && this.props.importError.validation.accounts !== undefined) {
                importError = (
                    <div ref={this.importErrorRef} className="import-results-error">
                        All accounts selected for import must be active.
                    </div>
                );
            }
        }

        if (this.state.localErrors.hashStatic) {
            hashtagError = (
                <div className="import-results-error">
                    {this.state.localErrors.hashStatic}
                </div>
            );
        }

        return (
            <div className="import-results-wrapper">
                <div className="import-settings">
                    <h2>Bulk Import Settings</h2>
                    {importError}
                    <div className="import-settings-controls">
                        <div className="import-socials">
                            {socialDisplay}
                            {editControl}
                        </div>
                        <div className={selectors.importParams}>
                            <div className="import-param">
                                <DropdownList
                                    data={this.state.categories}
                                    dataKey='id'
                                    filter={false}
                                    renderListItem={({ item }) => {
                                        return (
                                            <CategoryItem
                                                item={item}/>
                                        );
                                    }}
                                    renderValue={({ item }) => {
                                        return (
                                            <CategoryItem
                                                item={item}/>
                                        );
                                    }}
                                    placeholder="Choose Category"
                                    className="category-drop importer"
                                    defaultValue={tagID}
                                    onChange={this.onCategoryChange} />
                            </div>
                            <div className="import-param">
                                <ToggleControl
                                    active={addToQueue}
                                    activeLabel="Add items to Queue"
                                    inactiveLabel="Add items to Queue"
                                    linkedField="params.postQueueFlag"
                                    callback={this.onInputChange}
                                    labelPlacement="right" />
                            </div>
                            <div className="import-param">
                                <ToggleControl
                                    active={addToEverqueue}
                                    activeLabel="Add items to EverQueue"
                                    inactiveLabel="Add items to EverQueue"
                                    linkedField="params.postPoolFlag"
                                    callback={this.onEverqueueChange}
                                    labelPlacement="right" />
                            </div>
                            {attributionControl}
                            {hashtagControl}
                        </div>
                    </div>
                </div>
                <div className="item-display">
                    <h2>Select Items to Import and Schedule</h2>
                    <div className="display-controls">
                        <Breakpoint desktop only>
                            <div className="control-label">View:</div>
                            <div className="view-controls">
                                <div className={selectors.displayGrid} onClick={this.toggleDisplay} data-display='grid' role="button" aria-label="use grid view">
                                    <i className="icon ion-ios-grid-view"></i>
                                </div>
                                <div className={selectors.displayList} onClick={this.toggleDisplay} data-display='list' role="button" aria-label="use list view">
                                    <i className="icon ion-ios-list"></i>
                                </div>
                            </div>
                            <div className="selection-controls">
                                <span className="control-label">Select</span> <span className="selection-control" onClick={this.bulkSelect} data-action="all" role="button" aria-label="select all">ALL</span> | <span className="selectionControl" onClick={this.bulkSelect} data-action="none" role="button" aria-label="select none">NONE</span>
                            </div>
                        </Breakpoint>
                        <Breakpoint mobile only>
                            <div className="selection-controls">
                                <span className="control-label">Select</span> <span className="selection-control" onClick={this.bulkSelect} data-action="all" role="button" aria-label="select all">ALL</span> | <span className="selectionControl" onClick={this.bulkSelect} data-action="none" role="button" aria-label="select none">NONE</span>
                            </div>
                        </Breakpoint>
                    </div>
                    <ul className={"item-display-list clearfix " + this.state.display}>
                        {this.props.items.map((item, i) => {
                            let itemType = this.state.display,
                                id = i,
                                selected = false,
                                constants = this.props.app.config.constants;

                            if (item.id) {
                                id = item.id;
                            }

                            if (this.state.selectedItems.find((id) => { return item.id === id; }) !== undefined) {
                                selected = true;
                            }

                            if (this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
                                if (parseInt(this.props.service) === constants.BULK_SVC_TWITTER) {
                                    return;
                                }
                            }

                            return (
                                <li key={id}>
                                    <ImportItemDisplay
                                        {...this.props}
                                        displayType={this.state.display}
                                        item={item}
                                        context={"importer"}
                                        selectedItems={this.state.selectedItems}
                                        onItemSelect={this.selectItem}
                                        service={this.props.service}
                                        selected={selected}/>
                                </li>
                            );

                        })}
                    </ul>
                </div>
                {importFooter}
            </div>
        );
    }
}

ImportResults.displayName = "ImportResults";

ImportResults.propTypes = {
    items: PropTypes.array,
    service: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    chooseSocials: PropTypes.func,
    selectedSocials: PropTypes.array,
    onImportItems: PropTypes.func,
    importComplete: PropTypes.bool,
    context: PropTypes.string
};

ImportResults.defaultProps = {
    items: [],
    service: 0,
    chooseSocials: () => {},
    selectedSocials: [],
    onImportItems: () => {},
    importComplete: false,
    context: 'social'
};

export default ImportResults;
